import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';
import { TokenStorageService } from './token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class OrderService { 
  baseUrl = environment.baseUrl;

  constructor(
    private router: Router, 
    private http: HttpClient, 
    private tokenStorage: TokenStorageService
  ) { }
  
  getOrders$(uuid: string, page: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    let offset = page * 10;
    return this.http.get<any>(url + 'list?uuid=' + uuid + '&offset=' + offset);
  }

  getOrder$(uuid: string, order_id: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    return this.http.get<any>(url + '?order_id=' + order_id + '&uuid=' + uuid);
  }

  modifyOrder$(uuid: string, order_id: number, orderInfo: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    return this.http.put<any>(url + '?order_id=' +order_id +'&uuid=' + uuid, orderInfo, httpOptions);
  }

  searchOrder$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    let offset = page * 10;
    console.log(url + 'search?query=' + search + '&uuid=' + uuid + '&offset=' + offset);
    return this.http.get<any>(url + 'search?query=' + search + '&uuid=' + uuid + '&offset=' + offset);
  }

  getOrderListDelivery$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'truck-types?uuid=' + uuid);
  }

   //export order for print
  exportOrderPrint$(uuid: string, orderId: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    return this.http.get<any>(url + orderId + '/export/html?uuid=' + uuid, httpOptions);
  }

  getOrdertemplate$(uuid: string, template_name: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    return this.http.get<any>(url + 'order_item_templates?order_item_template_name=' + template_name + '&uuid=' + uuid);
  }

  
}
